import { render } from "./ArenaLoadingView.vue?vue&type=template&id=5195c5be&scoped=true"
import script from "./ArenaLoadingView.vue?vue&type=script&lang=js"
export * from "./ArenaLoadingView.vue?vue&type=script&lang=js"

import "./ArenaLoadingView.vue?vue&type=style&index=0&id=5195c5be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5195c5be"]])

export default __exports__